module.exports = __webpack_public_path__ + "img/poster.0eff9bba.png";